import React from 'react';
import styled from 'themes';
import { Button, Dropdown, Menu } from 'antd';
import dayjs from 'dayjs';
import { TermsKindCode } from 'store';

type SelectBoxProps = {
  data: { date: string; termsId: number }[];
  onSelect: (termsId: number) => void;
  query: { type: TermsKindCode; termsId: string | undefined };
};

const SelectBox = ({ data, onSelect, query }: SelectBoxProps) => {
  const selectedData = data.filter(item => {
    return `${item.termsId}` === query.termsId;
  });

  if (selectedData.length < 1) {
    return null;
  }

  return (
    <Container>
      {data?.length > 0 && (
        <Dropdown
          overlay={
            <Menu
              items={data.map(item => {
                return {
                  key: item.termsId,
                  label: dayjs(item.date).format('YYYY-MM-DD'),
                  onClick: () => onSelect(item.termsId),
                };
              })}
            />
          }
          placement="bottomLeft"
          trigger={['click']}>
          <Button>{dayjs(selectedData[0]?.date).format('YYYY-MM-DD')}</Button>
        </Dropdown>
      )}
    </Container>
  );
};

export default React.memo(SelectBox);

const Container = styled.div``;
